import type { SVGProps } from 'react';
export const SvgTwitterX = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={40}
		height={40}
		fill="none"
		viewBox="0 0 40 40"
		{...props}
	>
		<rect width={40} height={40} fill="#000" rx={10} />
		<path
			fill="#fff"
			d="m8.059 8.51 9.267 12.429L8 31.04h2.1l8.162-8.847 6.596 8.847H32l-9.787-13.126 8.679-9.405h-2.097l-7.518 8.147-6.073-8.147zm3.087 1.549h3.282l14.488 19.43h-3.282z"
		/>
	</svg>
);
